import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondary100};
  .data-show {
    span {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 600;
      &:first-of-type {
        cursor: pointer;
      }
    }
  }
  .pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    div {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.secondary10};
      border-radius: 8px;
    }
  }
`;

export const DropMenu = styled.div`
  border-radius: 8px;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.secondary10};
  color: ${({ theme }) => theme.colors.secondary100};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  gap: 10px;
  padding: 5px 0px;
  li {
    cursor: pointer;
    text-align: center;
    width: 100%;
    transition: all 0.4s;
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.secondary10};
    }
  }
`;
